"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var create_error_1 = __importDefault(require("./create-error"));

var defaults_1 = require("../defaults");

var drainAccessoriesItems = defaults_1.configurationDefaults.drainAccessories.drain.allValues || [];

exports.validateDrain = function (drainAccessories, defaults, trough, configuration) {
  var error = undefined;
  var accessoriesDefaults = defaults.drain.values;
  /*
  drainAccessoriesItems.map(key => {
    if (key === 'hood-chrome') {
      if (trough.hoodChrome === true) {
        accessoriesDefaults.push('hood-chrome');
      }
    }
    if (key === 'hood') {
      if (trough.hood === true) {
        accessoriesDefaults.push('hood');
      }
    }
    if (key === 'sieve') {
      if (trough.sieve === true) {
        accessoriesDefaults.push('sieve');
      }
    }
    if (key === 'eccentric') {
      if (trough.eccentricOffFlow === true && trough.eccentricOverFlow === true) {
        accessoriesDefaults.push('eccentric');
      }
    }
  });
  */

  if (configuration.isWithOverflow) {
    accessoriesDefaults = ['without', 'hood-chrome'];
  }

  if (configuration.isVariusParis || configuration.isVariusMedMzb || configuration.isExos && !trough.hood) {
    accessoriesDefaults = ['without'];
  }

  if (accessoriesDefaults.indexOf(drainAccessories.drain) === -1) {
    error = create_error_1.default({
      msg: "Drain accessories {{" + drainAccessories.drain + "}} isn't assignable.",
      code: 'NOT_ASSIGNABLE',
      inObject: 'drainAccessories.drain',
      statusCode: 400
    });
  }

  defaults.drain.values = accessoriesDefaults;
  return error ? error : defaults;
};

exports.validateSiphon = function (drainAccessories, defaults, trough, configuration) {
  var error = undefined;
  var siphon = drainAccessories && drainAccessories.siphon;

  if (trough.siphon === false) {
    defaults.siphon.values = [false];

    if (siphon === true) {
      error = create_error_1.default({
        msg: "Siphon can't be assign to {{" + trough.name + "}}",
        code: 'NOT_ASSIGNABLE',
        inObject: 'drainAccessories.siphon',
        statusCode: 400
      });
    }
  } else {
    defaults.siphon.values = [false, true];
  }

  if (configuration.isVariusMedMzb) {
    defaults.siphon.values = [];
  }

  return error ? error : defaults;
};

exports.validateDrainAccessories = {
  drain: exports.validateDrain
};
exports.default = exports.validateDrainAccessories;